<template>
    <div>
        <div class="container">
            <Notification />
        </div>
        <div class="container bg-light p-2 mt-4">
            <div class="row">
                <a href="#" class="col col-2" v-if="showHome && $store.state.currentCabinet && isLoggedIn" @click="goToHome()">
                    <button class="btn btn-default btn-sm">
                        <i class="fas fa-home"></i>
                    </button>
                </a>
                <div class="col col-10 input-group" :class="[ !showHome || !$store.state.currentCabinet || !isLoggedIn ?  'offset-2' : '' ]">
                    <select class="custom-select custom-select-sm" :value="currentCabinet" @change="setCurrentCabinet($event)">
                        <option v-for="cabinet in $store.state.cabinets" :key="cabinet.nom">{{ cabinet.nom }}</option>
                    </select>
                    <div class="input-group-append">
                        <button class="btn btn-sm btn-outline-secondary" @click="showCabinets()" data-toggle="tooltip" data-placement="top" title="Editer les cabinets">
                            <i class="fas fa-pencil-alt"></i>
                        </button>
                        <button class="btn btn-outline-secondary btn-sm" @click="newLogin()" data-toggle="tooltip" data-placement="top" title="Editer le compte" :class="$store.state.currentCabinet ? 'visible' : 'invisible'">
                            <i class="fas fa-user-edit"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="row mt-5 justify-content-center" v-if="loginFormVisible">
                <div>
                    <div v-if="isLoggedIn">
                        Connecté en tant que <strong>{{ $store.state.currentCabinet.credentials.username }}</strong>
                    </div>
                    <div class="form-group">
                        <input type="email" class="form-control" placeholder="Nom d'utilisateur" v-model="username" v-if="!isLoggedIn">
                    </div>
                    <div class="form-group">
                        <input type="password" class="form-control" placeholder="Mot de passe" v-model="password" v-if="!isLoggedIn" v-on:keyup.enter="signin()">
                    </div>
                    <div class="text-center">
                        <button type="button" class="btn btn-dark btn-sm" @click="signin()" :disabled="isSigningIn" v-if="!isLoggedIn">
                            <i class="fas fa-spinner fa-spin" v-if="isSigningIn"></i>
                            Connexion
                        </button>
                        <button type="button" class="btn btn-danger btn-sm" @click="signout()" :disabled="isSigningIn" v-if="isLoggedIn">
                            <i class="fas fa-spinner fa-spin" v-if="isSigningIn"></i>
                            Déconnexion
                        </button>
                    </div>
                </div>
            </div>
            <Cabinets :cabinetsVisible="cabinetsVisible" :cabinetFormVisible="cabinetFormVisible" :cabinets-visible.sync="cabinetsVisible" :cabinet-form-visible.sync="cabinetFormVisible"
                :update:loginFormVisible.sync="loginFormVisible" @show-cabinets="showCabinets($event)"
            />
        </div>
    </div>
</template>

<script lang="ts">
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.css';
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { mixins } from 'vue-class-component'
import credentialsStore from '../store/credentials-store'
import { Cabinet } from '../interfaces/interfaces'
import LysiasApiMixin from '../mixins/LysiasApiMixin'
import SettingsMixin from '../mixins/SettingsMixin'
//import '@microsoft/office-js/dist/office'
import Notification from './Notification.vue'
import Cabinets from './Cabinets.vue'


@Component({
    store: credentialsStore,
    components: { Notification, Cabinets }
})
export default class Login extends mixins(LysiasApiMixin, SettingsMixin)
{
    isSigningIn = false;
    username = "";
    password = "";
    handlerAdded = false;

    @Prop({ default: null }) readonly showHome?: string;

    @Watch('cabinets', { immediate: true, deep: true })
    async onCabinetsChanged()
    {
        if(!this.$store.state.currentCabinet && this.$store.state.cabinets.length)
        {
            this.$store.commit('setCurrentCabinet', this.$store.state.cabinets[0]);

            if(this.$store.state.capabilities.length == 0 && this.$store.state.cabinets[0].credentials) {
                const username = this.$store.state.cabinets[0].credentials.username;
                const password = this.$store.state.cabinets[0].credentials.password;

                await this.login(username, password);
            }
        }
        else if(this.$store.state.currentCabinet && this.$store.state.currentCabinet.credentials.isLoggedIn && this.$store.state.capabilities.length == 0)
        {
            const username = this.$store.state.currentCabinet.credentials.username;
            const password = this.$store.state.currentCabinet.credentials.password;

            await this.login(username, password);
        }

        if(this.$store.state.cabinets.length == 0)
        {
            this.$store.commit('setCurrentCabinet', null);
        }
    }

    @Watch('currentCabinet')
    onCurrentCabinetChanged()
    {
        this.username = this.$store.state.currentCabinet?.credentials.username;
        this.password = this.$store.state.currentCabinet?.credentials.password;
    }

    get cabinets()
    {
        return this.$store.state.cabinets;
    }

    get currentCabinet()
    {
        if(this.$store.state.currentCabinet)
        {
            return this.$store.state.currentCabinet.nom;
        }

        return "";
    }

    get isLoggedIn(): boolean
    {
        return this.$store.state.currentCabinet != null && this.$store.state.currentCabinet.credentials.isLoggedIn;
    }

    setCurrentCabinet(e: any)
    {
        console.log(typeof e);
        console.log(e.target);
        this.$store.commit('setCurrentCabinet', this.$store.state.cabinets.find((cabinet: Cabinet) => cabinet.nom == e.target.value));
        this.username = this.$store.state.currentCabinet.credentials.username;
        this.password = this.$store.state.currentCabinet.credentials.password;
    }

    async signin()
    {
        console.log(this);
        this.isSigningIn = true;
        const validLogin = await this.login(this.username, this.password);
        console.log('done');
        this.isSigningIn = false;
        if(validLogin)
        {
            const index = this.cabinets.findIndex((cabinet: Cabinet) => cabinet.nom == this.$store.state.currentCabinet.nom);
            this.$store.commit('setUsername', this.username);
            this.$store.commit('setPassword', this.password);

            this.saveCabinets();
            this.$router.push({ name: 'linked' });
            this.$store.commit('setLoginFormVisible', false);
            this.$store.commit('setCabinetFormVisible', false);
            this.$store.commit('setCabinetsVisible', false);
        }
    }

    async signout()
    {
        this.username = '';
        this.password = '';
        this.$store.commit('setUsername', '');
        this.$store.commit('setPassword', '');
        this.$store.commit('setIsLoggedIn', { nom: this.$store.state.currentCabinet.nom, isLoggedIn: false });
        this.saveCabinets();
    }

    newLogin()
    {

        this.$store.commit('setLoginFormVisible', !this.$store.state.loginFormVisible);
        this.$store.commit('setCabinetFormVisible', false);
        this.$store.commit('setCabinetsVisible', false);
    }

    showCabinets(show?: boolean)
    {
        if(show == undefined)
        {
            show = !this.$store.state.cabinetsVisible;
        }

        this.$store.commit('setLoginFormVisible', false);
        this.$store.commit('setCabinetFormVisible', false);
        this.$store.commit('setCabinetsVisible', show);

    }

    get loginFormVisible(): boolean
    {
        return this.$store.state.loginFormVisible;
    }

    get cabinetFormVisible(): boolean
    {
        return this.$store.state.cabinetFormVisible;
    }

    get cabinetsVisible(): boolean
    {
        return this.$store.state.cabinetsVisible;
    }

    goToHome()
    {
        if(this.$store.state.linkedDossiers.length)
        {
            this.$router.push({ name: 'linked' });
        }
        else
        {
            this.$router.push({ name: 'search' });
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
